import { ReactChildren } from "../../../services/model/types";

type InputProps = {
  height: string;
  className?: string;
};
export function ViewHeightContainer(props: ReactChildren & InputProps) {
  return (
    <div
      className={props.className}
      style={{
        minHeight: props.height,
      }}
    >
      {props.children}
    </div>
  );
}
